'use client';

import '@/instrumentation-client';

export default function SentryInit() {
  return null;
}
